import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu01, X } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";

const navLinks = [
  { name: "Features", href: "#features" },
  { name: "How It Works", href: "#how-it-works" },
  { name: "Pricing", href: "#pricing" },
  { name: "FAQ", href: "#faq" },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "py-3 bg-bg-primary/80 backdrop-blur-lg shadow-xs"
          : "py-5 bg-transparent"
      }`}
    >
      <div className="landing-container flex items-center justify-between">
        <Link to="/" className="text-lg font-semibold text-text-primary">
          My Garage
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <ul className="flex space-x-6">
            {navLinks.map((link) => (
              <li key={link.name}>
                <a
                  href={link.href}
                  className="text-sm font-medium text-text-tertiary hover:text-text-primary transition-colors"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
          <div className="flex items-center space-x-3">
            <Link to="/login">
              <Button color="secondary" size="sm">
                Sign In
              </Button>
            </Link>
            <Link to="/login">
              <Button color="primary" size="sm">
                Get Started
              </Button>
            </Link>
          </div>
        </nav>

        {/* Mobile Menu Toggle */}
        <div className="flex items-center md:hidden">
          <Button
            color="tertiary"
            size="sm"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-5 w-5" />
            ) : (
              <Menu01 className="h-5 w-5" />
            )}
          </Button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-bg-primary/95 backdrop-blur-md shadow-lg border-t border-border-secondary">
          <nav className="landing-container py-6">
            <ul className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="block py-2 text-base font-medium text-text-primary"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex flex-col space-y-3">
              <Link to="/login">
                <Button color="secondary" className="w-full justify-center">
                  Sign In
                </Button>
              </Link>
              <Link to="/login">
                <Button color="primary" className="w-full justify-center">
                  Get Started
                </Button>
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
